// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "admin" + "." + "3fed9bc4" + ".js";
};